import { createSelector } from "reselect";

export const getLocationEnabled = createSelector(
  [state => state.location.enabled],
  enabled => enabled,
);
